import { AlgorithmType } from '@/common/api/params/analytics'

export const algorithmName = (algorithm: AlgorithmType) => {
  switch (algorithm) {
    case AlgorithmType.CONTENT_BASED:
      return 'コンテンツベース'
    case AlgorithmType.HYBRID:
      return 'ハイブリッド'
    case AlgorithmType.COLLABORATIVE:
      return '協調フィルタリング'
    case AlgorithmType.POPULARITY:
      return '人気順'
    default:
      return algorithm
  }
}
